/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.playlists.rpc.LearningPathChirpService
 */

export const SimpleLearningPathResponseTypename = 'com.hubspot.learning.center.playlists.core.playlist.api.internal.learningpath.pagination.SimpleLearningPathResponse';
export const SimpleStandardPlaylistResponseTypename = 'com.hubspot.learning.center.playlists.core.playlist.api.internal.learningpath.pagination.SimpleStandardPlaylistResponse';
export const getRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'get',
  auth: 'app',
  fingerprint: '902ySleQCngIvf5RXWBcYQNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistOrLearningPathRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getPlaylistOrLearningPath',
  auth: 'app',
  fingerprint: '902ySleQCniTTIjeDyot_ANaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getPlaylistsOrLearningPathsRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getPlaylistsOrLearningPaths',
  auth: 'app',
  fingerprint: '_XF6ceJ-jiKqdqhYCzJRqwNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllPaginatedRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getAllPaginated',
  auth: 'app',
  fingerprint: '5wAjhr_5tnwsMeouDwl9ngNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getLearningPathsRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getLearningPaths',
  auth: 'app',
  fingerprint: 'G2qJKgEVkS9CGbrW6Er2wgNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSimpleLearningPathsOrPlaylistsRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getSimpleLearningPathsOrPlaylists',
  auth: 'app',
  fingerprint: 'VpwY3Z8oCPc-5rp_yR72zgNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllPaginatedInternalRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'getAllPaginatedInternal',
  auth: 'app',
  fingerprint: '5wAjhr_5tnwsMeouDwl9ngNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'Ass50LMBGJEIvf5RXWBcYQNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createFromPlaylistRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'createFromPlaylist',
  auth: 'app',
  fingerprint: 'aiu_ihVtOK4Ivf5RXWBcYQNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'mX-VI-ZupaYIvf5RXWBcYQNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteRpc = {
  serviceName: 'com.hubspot.learning.center.playlists.rpc.LearningPathChirpService',
  rpcName: 'delete',
  auth: 'app',
  fingerprint: '360j63y7xP8DFLtas3o9fQNaOMGUZfsO',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};